import React from 'react';

import DataContainer from 'Components/UI/DataContainer';
import { useIncludedRelationshipContext } from 'Views/Page/Contexts/IncludedRelationshipContext';
import PropTypes from 'prop-types';
import Content from './Content';

const Container = ({
  resource,
  isChild,
  onClickItem,
}) => {
  const { isInitializing } = useIncludedRelationshipContext();

  return (
    <DataContainer
      loading={isInitializing}
      component={Content}
      componentProps={{
        resource,
        isChild,
        onClickItem,
      }}
    />
  );
};

Container.defaultProps = {
  onClickItem: null,
};

Container.propTypes = {
  resource: PropTypes.object.isRequired,
  isChild: PropTypes.bool.isRequired,
  onClickItem: PropTypes.func,
};


export default Container;
